export default {
  
  en: {
    requestDate: 'Date',
    productType: 'Product Type',
    installNum: 'Install num',
    transRate: 'Translate rate',
    regSubMobileDistinctNum: 'Submit mobile distinct num',
    regSubMobileNum: 'Submit mobile num',
    avgSubNum: 'Avg Submit Num',
    regSubValidMobileDistinctNum: 'Submit valid mobile distinct num',
    subValidMobileProportion: 'Submit valid mobile proportion',
    regSendOtpNum: 'Send otp num',
    regSendOtpMobileDistinctNum: 'Send otp mobile distinct num',
    avgSendNumEveryMobile: 'Avg send num every mobile',
    regOperateSucceedNum: 'Operate succeed num',
    regOperateFailNum: 'Operate fail num',
    unLoginNum: 'Unlogin num',
    lockOtpNum: 'Lock otp num',
    regLockOperateNum: 'Lock operate num',
    regSuccessRateByTime: 'Success rate by time',
    regSuccessRateByMobile: 'Success rate by mobile',
    loginSubMobileDistinctNum: 'Login sub mobile distinct num',
    loginSubValidMobileDistinctNum: 'Login sub valid mobile distinct num',
    sendOtpNum: 'Send otp num',
    loginSendOtpMobileDistinctNum: 'Login send otp mobile distinct num',
    loginOperateSucceedNum: 'Login operate succeed num',
    loginOperateFailNum: 'Login operate fail num',
    loginLockOperateNum: 'Login lock operate num',
    loginSuccessRateByTime: 'Login success rate by time',
    loginSuccessRateByMobile: 'Login success rate by mobile',
    loginSubMobileNum: 'Login submit mobile num',
    validCodeCount: 'Submit the number of unique valid entries',
    userMobile: "User's phone number",
    queryTime: 'query time',
    action: 'Operation (event)',
    happenTime: 'Time of occurrence',
    outParamInParam: 'Input/Output parameters',
    expand: 'Expand',
    collapse: 'Collapse',

  },
  es: {
    requestDate: 'Ngày',
    productType: 'Loại sản phẩm',
    installNum: 'Lượt cài đặt',
    transRate: 'Chuyển đổi',
    regSubMobileDistinctNum: 'Số lượng số điện thoại chưa đăng ký (sau khi loại trùng)',
    regSubMobileNum: 'Số lần gửi số điện thoại chưa đăng ký',
    avgSubNum: 'Số lần gửi trung bình',
    regSubValidMobileDistinctNum: 'Số lượng số điện thoại hợp lệ chưa đăng ký (sau khi loại trùng)',
    subValidMobileProportion: 'Tỷ lệ số điện thoại hợp lệ',
    regSendOtpNum: 'Số tin nhắn OTP đăng ký được gửi',
    regSendOtpMobileDistinctNum: 'Số lượng số điện thoại nhận OTP (loại trùng)',
    avgSendNumEveryMobile: 'Số OTP trung bình/ mỗi số điện thoại',
    regOperateSucceedNum: 'Số lượng số điện thoại đăng ký thành công',
    regOperateFailNum: 'Số lượng số điện thoại đăng ký thất bại',
    unLoginNum: 'Số lượng số điện thoại chưa gửi yêu cầu đăng nhập',
    lockOtpNum: 'Số lượng số điện thoại bị khóa OTP do dùng hết lượt OTP',
    regLockOperateNum: 'Số lượng số điện thoại bị khóa nhưng chưa đăng ký thành công',
    regSuccessRateByTime: 'Tỷ lệ đăng ký thành công (theo lượt thực hiện)',
    regSuccessRateByMobile: 'Tỷ lệ đăng ký thành công (theo số điện thoại)',
    loginSubMobileDistinctNum: 'Số lượt gửi mã đăng nhập (đã loại trùng)',
    loginSubMobileNum: 'Số lần gửi mã đăng nhập',
    loginSubValidMobileDistinctNum: 'Số lượt gửi số hợp lệ (đã loại trùng)',
    subValidMobileProportion: 'Tỷ lệ số hợp lệ',
    sendOtpNum: 'Số SMS OTP đã gửi',
    loginSendOtpMobileDistinctNum: 'Số thuê bao nhận OTP (đã loại trùng)',
    avgSendNumEveryMobile: 'Số OTP trung bình/thuê bao',
    loginOperateSucceedNum: 'Số thuê bao đăng nhập thành công',
    loginOperateFailNum: 'Số thuê bao đăng nhập thất bại',
    unLoginNum: 'Số thuê bao không gửi yêu cầu đăng nhập',
    lockOtpNum: 'Số thuê bao bị khóa do dùng hết lượt OTP',
    loginLockOperateNum: 'Số thuê bao bị khóa nhưng chưa đăng nhập',
    loginSuccessRateByTime: 'Tỷ lệ đăng nhập thành công (theo lượt thực hiện)',
    loginSuccessRateByMobile: 'Tỷ lệ đăng nhập thành công (theo số điện thoại)',
    validCodeCount: 'Số lượng số điện thoại hợp lệ (đã loại trừ trùng lặp)',
    userMobile: 'Số điện thoại người dùng',
    queryTime: 'thời gian truy vấn',
    action: 'Hoạt động (Sự kiện)',
    happenTime: 'thời gian xảy ra',
    outParamInParam: 'tham số đầu vào/tham số đầu ra',
    expand: 'Expmở rộngndir',
    collapse: 'thu lại',
  }
}
